import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { UzurvDirectivesModule } from '@uzurv/core';
import { AlertDialogModule } from '../alert-dialog/alert-dialog.module';
import { CopyHolidayScheduleComponent } from './copy-holiday-schedule-dialog.component';

@NgModule({
  declarations: [CopyHolidayScheduleComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    AlertDialogModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    UzurvDirectivesModule,
    MatDatepickerModule,
    MatIconModule,
    MatRadioModule,
    MatSelectModule
  ],
  exports: [CopyHolidayScheduleComponent]
})
export class CopyHolidayScheduleModule {}
